/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Copy body or face</h4>

<p>Select one or more bodies and/or faces, and make exact copies of them.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('566451618')}" loading="lazy"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>Ctrl-C</b>: Copy body or face</li>
</ul>`;

export default function CopyTooltip() {
    return h('div', { innerHTML: body });
}
